import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './button.scss';

const NewsButton = () => {
    function reportLink() {
        window.open("https://t.me/youtobedownload", "_blank");
    }

    return (
            <button
                onClick={reportLink}
                className="button-news flex items-center justify-center w-16 h-16 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                aria-label="App News"
            >
                <i className="fas fa-newspaper"></i>
                <div className="tooltip">App News</div>
            </button>
    );
};

export default NewsButton;
